(() => {
  function initializeGallery(gallery) {
    if (gallery.dataset.sczGalleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-scz-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-scz-gallery-thumb]'));
    const counter = gallery.querySelector('[data-scz-gallery-current]');
    if (!slides.length) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

    function select(index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== activeIndex;
      });
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        thumbnail.setAttribute('aria-current', thumbnailIndex === activeIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);
    }

    gallery.querySelector('[data-scz-gallery-prev]')?.addEventListener('click', () => select(activeIndex - 1));
    gallery.querySelector('[data-scz-gallery-next]')?.addEventListener('click', () => select(activeIndex + 1));
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => select(index)));

    select(activeIndex);
    gallery.dataset.sczGalleryReady = 'true';
  }

  function initializeGalleries(root = document) {
    root.querySelectorAll('[data-scz-product-gallery]').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGalleries(), { once: true });
  } else {
    initializeGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));
})();
